// Vocabulaire partagé des échanges clients — modale ET tableau des derniers
// contacts. Un seul endroit : deux copies divergeraient, comme le tri des
// tableaux avant `planning/TriTableau.js`.

// L'ordre est celui des boutons de saisie : les canaux les plus utilisés au
// comptoir d'abord.
export const CANAUX = [
  { id: 'appel',       sens: 'sortant', label: 'Appel sortant',  icone: '📞', court: 'Appel' },
  { id: 'appel',       sens: 'entrant', label: 'Appel entrant',  icone: '📲', court: 'Appel' },
  { id: 'email',       sens: 'sortant', label: 'E-mail',         icone: '✉️', court: 'E-mail' },
  { id: 'sms',         sens: 'sortant', label: 'SMS',            icone: '💬', court: 'SMS' },
  { id: 'whatsapp',    sens: 'sortant', label: 'WhatsApp',       icone: '🟢', court: 'WhatsApp' },
  { id: 'face_a_face', sens: 'sortant', label: 'Face à face',    icone: '🤝', court: 'Face à face' },
];

export const ICONE_CANAL = {
  appel: '📞', sms: '💬', email: '✉️', whatsapp: '🟢', face_a_face: '🤝', courrier: '📮',
};
export const LIBELLE_CANAL = {
  appel: 'Appel', sms: 'SMS', email: 'E-mail', whatsapp: 'WhatsApp',
  face_a_face: 'Face à face', courrier: 'Courrier',
};

// Résultats : ne concernent vraiment que l'appel. Laisser le choix ouvert
// ailleurs n'apporterait rien et ferait un menu de plus à comprendre.
export const RESULTATS = [
  { id: 'joint',          label: 'Joint',          ton: 'ok' },
  { id: 'sans_reponse',   label: 'Sans réponse',   ton: 'ko' },
  { id: 'messagerie',     label: 'Messagerie',     ton: 'attente' },
  { id: 'rappel_demande', label: 'Rappel demandé', ton: 'attente' },
];

// « aujourd'hui 09:12 », « hier 16:40 », « 19/08 11:05 » — même grammaire que
// les pastilles de statut (utils/statutAtelier.js) : le réceptionnaire lit la
// même chose partout.
export function libelleQuand(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const heure = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const jour = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const auj = new Date(); const aujJ = new Date(auj.getFullYear(), auj.getMonth(), auj.getDate());
  const ecart = Math.round((aujJ - jour) / 86400000);
  if (ecart === 0) return `Aujourd'hui ${heure}`;
  if (ecart === 1) return `Hier ${heure}`;
  return `${d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })} ${heure}`;
}

// Ancienneté d'un contact, pour le badge et la colonne du tableau.
// `null` = jamais contacté : c'est une information, pas un trou à masquer.
export function ancienneteContact(iso) {
  if (!iso) return { texte: 'Jamais contacté', jours: null, alerte: true };
  const d = new Date(iso);
  const jour = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const auj = new Date(); const aujJ = new Date(auj.getFullYear(), auj.getMonth(), auj.getDate());
  const j = Math.round((aujJ - jour) / 86400000);
  if (j <= 0) return { texte: "aujourd'hui", jours: 0, alerte: false };
  if (j === 1) return { texte: 'hier', jours: 1, alerte: false };
  return { texte: `il y a ${j} jours`, jours: j, alerte: j >= 5 };
}
